import { createAction, props } from '@ngrx/store';

export const setUserRoleInfo = createAction(
  '[User Role] Set User Role Information',
  props<{ userRole: any }>(),
);
